module.exports = __webpack_public_path__ + "img/png_title_yaoqiu.3d46b4b6.png";